var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Companies_Outline_WhatsApp",
    "data-name": "Icon/Companies/Outline/WhatsApp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.002,
    height: 32.002,
    viewBox: "0 0 32.002 32.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M.392,31.331a1.755,1.755,0,0,1-.35-1.483l.053-.189L2.87,21.327l-.2-.485a14.955,14.955,0,0,1-1.07-4.99l-.011-.643A15.222,15.222,0,0,1,16.753,0h.04l.888,0A15.208,15.208,0,0,1,32,14.419V15.2A15.215,15.215,0,0,1,16.8,30.418h-.05a14.916,14.916,0,0,1-5.589-1.082l-.486-.206L2.342,31.907A1.8,1.8,0,0,1,1.771,32,1.767,1.767,0,0,1,.392,31.331ZM11.582,4.79A11.637,11.637,0,0,0,6.369,20.412a1.789,1.789,0,0,1,.1,1.365L4.592,27.41l5.633-1.878a1.757,1.757,0,0,1,.562-.091,1.779,1.779,0,0,1,.586.1l.218.093a11.538,11.538,0,0,0,5.171,1.23h.03A11.67,11.67,0,0,0,28.447,15.209l0-.691A11.614,11.614,0,0,0,17.511,3.555h.022l-.05,0,.016,0h-.742A11.541,11.541,0,0,0,11.582,4.79ZM21.749,21.327a12.386,12.386,0,0,1-5.4-1.917,12.2,12.2,0,0,1-3.755-3.747,12.327,12.327,0,0,1-1.92-5.414,1.248,1.248,0,0,1,1.245-1.36h2.306c.627-.006.734.453.822,1.074a8.081,8.081,0,0,0,.438,1.755,1.247,1.247,0,0,1-.282,1.317l-.8.794a10.014,10.014,0,0,0,3.755,3.747l.794-.794a1.258,1.258,0,0,1,1.322-.282,8,8,0,0,0,1.757.437,1.251,1.251,0,0,1,1.077,1.269v1.874a1.249,1.249,0,0,1-1.249,1.253Q21.806,21.332,21.749,21.327ZM17.5,3.555h.011Z",
    transform: "translate(0)",
    fill: "#091119"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7f66e86323df9d82da48fa66d3af023a.svg";
export { ForwardRef as ReactComponent };